import { Injectable, EventEmitter } from "@angular/core";
import { Subscription } from "rxjs/internal/Subscription";
import {
  DialogEventArgs,
  MsgBoxIcon,
  TextColor,
  MsgBoxButtons,
  DialogConfig
} from "./msgbox.helper";
import { BsModalService, BsModalRef } from "ngx-bootstrap";
import { IMsgBoxOption } from "./msgbox.interfaces";
import { MsgboxContent } from "./msgbox-content/msgbox-content.component";
import { ModalOption } from "../../helpers/modal-option";

@Injectable({
  providedIn: "root"
})
export class MsgBoxService {
  private _modalRef: BsModalRef;
  private _subscriptions: Subscription[] = [];

  eventWatcher = new EventEmitter<DialogEventArgs>();

  constructor(private _modalService: BsModalService) {}

  hide() {
    this._modalRef.hide();
  }

  private _subscribe() {
    this._subscriptions.push(
      this._modalService.onShow.subscribe((reason: string) => {
        this.eventWatcher.emit(new DialogEventArgs("show"));
      })
    );

    this._subscriptions.push(
      this._modalService.onShown.subscribe((reason: string) => {
        this.eventWatcher.emit(new DialogEventArgs("shown"));
      })
    );

    this._subscriptions.push(
      this._modalService.onHide.subscribe((reason: string) => {
        this.eventWatcher.emit(
          new DialogEventArgs("hide", this._modalRef.content)
        );
      })
    );

    this._subscriptions.push(
      this._modalService.onHidden.subscribe((reason: string) => {
        this.eventWatcher.emit(
          new DialogEventArgs("hidden", this._modalRef.content)
        );
        this._unsubscribe();
      })
    );
  }

  private _unsubscribe() {
    this._subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this._subscriptions = [];
  }

  confirmDelete(options?: IMsgBoxOption) {
    const opts = Object.assign(
      {
        title: "Eliminar",
        message: "Â¿Esta seguro que desea eliminar el registro?",
        icon: MsgBoxIcon.Question,
        iconColor: TextColor.Danger,
        buttons: MsgBoxButtons.DeleteConfirm,
        modalOption: {
          class: "modal-md"
        }
      },
      options
    );
    this.show(opts);
  }

  confirmAction(options?: IMsgBoxOption) {
    const opts = Object.assign(
      {
        icon: MsgBoxIcon.Question,
        iconColor: TextColor.Info,
        buttons: MsgBoxButtons.YesNo,
        modalOption: {
          class: "modal-md"
        }
      },
      options
    );
    this.show(opts);
  }

  show(options: IMsgBoxOption) {
    const initialState = Object.assign({}, options, {
      options: new DialogConfig({
        icon: options.icon,
        buttons: options.buttons,
        iconColor: options.iconColor
      }).createDefaultOptions()
    });

    this._modalRef = this._modalService.show(
      MsgboxContent,
      Object.assign(
        {
          initialState: initialState
        },
        Object.assign(new ModalOption(), options.modalOption)
      )
    );
  }
}
